import {Button, Modal} from "@mui/material";
import React from "react";
import styled from 'styled-components';

export const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  width: 90%;
  max-width: 360px;
  margin: auto;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
`;
export const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 4px 0;
  text-align: center;
`;
export const ModalSubtitle = styled.div`
  font-size: 12px;
  color: #666;
  text-align: center;
  margin: 0 0 16px 0;
`;
export const MethodTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #222;
`;
export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  align-items: center;
`;

export const ModalDialog = ({open, setOpen, children, title, subtitle}) => {
    return (
        <Modal open={open} onClose={() => setOpen(false)} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <ModalContent>
                <div style={{textAlign: 'center', padding: '10px 0'}}>
                    <ModalTitle>{title}</ModalTitle>
                    <ModalSubtitle>{subtitle}</ModalSubtitle>
                    <ActionsContainer>
                        {children}
                        <Button variant={"contained"} fullWidth onClick={() => setOpen(false)}>OK</Button>
                    </ActionsContainer>
                </div>
            </ModalContent>
        </Modal>
    );
}
